import { ModuleUserProgressStatus } from 'app/library/module-user/enums/module-user-progress-status.enum';
import { UserExtendedAttributeWithValue } from 'app/projects/user/src/lib/models/user-attribute-with-value';
import { ICourseOfferingMeBookingQuery } from '../interfaces/course-offering-me-booking.query.interface';

export class CourseOfferingMeBooking {
    bookingProgressStatus: ModuleUserProgressStatus | null;
    isCurrentlyListed: boolean;
    executionId: string;
    executionName: string;
    executionVersion: string;
    executionType: string;
    price: { amount: number | null; currency: string } | null;
    attributes: UserExtendedAttributeWithValue[];

    constructor(query: ICourseOfferingMeBookingQuery) {
        this.bookingProgressStatus = query.progress_status ?? null;
        this.isCurrentlyListed = !!query.is_currently_listed;
        this.executionId = query.execution.id.toString();
        this.executionName = query.execution.name;
        this.executionVersion = query.execution.version;
        this.executionType = query.execution.type;
        this.price = query.price;
        this.attributes = (query.execution.attributes || []).map(
            (attributeWithValue) => new UserExtendedAttributeWithValue(attributeWithValue.attribute, attributeWithValue.value)
        );
    }
}
